<template>
    <div class="col-lg-10 col-md-8 col-12 main">
        <Swiper :list="list" />
    </div>
</template>
<script>
import Swiper from "@/components/Swiper.vue";
export default {
    name: "home",
    components: {
        Swiper
    },
    data() {
        return {
            list: [
                { img: require("@/assets/resource/community_forum_activities/club_activities/1.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/2.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/3.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/4.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/5.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/6.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/7.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/8.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/9.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/10.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/11.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/12.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/13.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/14.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/15.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/16.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/17.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/18.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/19.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/20.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/21.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/22.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/23.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/24.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/25.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/26.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/27.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/28.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/29.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/30.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/31.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/32.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/33.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/34.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/35.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/36.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/37.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/38.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/39.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/40.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/41.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/42.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/43.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/44.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/45.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/46.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/47.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/48.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/49.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/50.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/51.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/52.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/53.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/54.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/55.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/56.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/57.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/58.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/59.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/60.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/61.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/62.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/63.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/64.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/65.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/66.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/67.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/68.jpg"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/club_activities/69.jpg"), alt: "123" }
                ]
        }
    },


};
</script>
<style scoped>
/* 
*{border:1px solid #000;} */

.main {
    height: 100vh;
    padding: 30px 15px;
}

@media (max-width: 768px) {
    .main {
        padding-top: 0px;
        height: calc(100vh - 90px);
    }

}
</style>
